<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_13_13489"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect
        width="16"
        height="16"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_13_13489)">
      <path
        d="M0.666504 13.3334V11.4667C0.666504 11.0889 0.763726 10.7417 0.958171 10.425C1.15262 10.1084 1.41095 9.86669 1.73317 9.70002C2.42206 9.35558 3.12206 9.09724 3.83317 8.92502C4.54428 8.7528 5.2665 8.66669 5.99984 8.66669C6.73317 8.66669 7.45539 8.7528 8.1665 8.92502C8.87761 9.09724 9.57762 9.35558 10.2665 9.70002C10.5887 9.86669 10.8471 10.1084 11.0415 10.425C11.2359 10.7417 11.3332 11.0889 11.3332 11.4667V13.3334H0.666504ZM12.6665 13.3334V11.3334C12.6665 10.8445 12.5304 10.375 12.2582 9.92502C11.9859 9.47502 11.5998 9.08891 11.0998 8.76669C11.6665 8.83335 12.1998 8.94724 12.6998 9.10835C13.1998 9.26947 13.6665 9.46669 14.0998 9.70002C14.4998 9.92224 14.8054 10.1695 15.0165 10.4417C15.2276 10.7139 15.3332 11.0111 15.3332 11.3334V13.3334H12.6665ZM5.99984 8.00002C5.2665 8.00002 4.63873 7.73891 4.1165 7.21669C3.59428 6.69447 3.33317 6.06669 3.33317 5.33335C3.33317 4.60002 3.59428 3.97224 4.1165 3.45002C4.63873 2.9278 5.2665 2.66669 5.99984 2.66669C6.73317 2.66669 7.36095 2.9278 7.88317 3.45002C8.40539 3.97224 8.6665 4.60002 8.6665 5.33335C8.6665 6.06669 8.40539 6.69447 7.88317 7.21669C7.36095 7.73891 6.73317 8.00002 5.99984 8.00002ZM12.6665 5.33335C12.6665 6.06669 12.4054 6.69447 11.8832 7.21669C11.3609 7.73891 10.7332 8.00002 9.99984 8.00002C9.87761 8.00002 9.72206 7.98613 9.53317 7.95835C9.34428 7.93058 9.18873 7.90002 9.0665 7.86669C9.3665 7.51113 9.59706 7.11669 9.75817 6.68335C9.91928 6.25002 9.99984 5.80002 9.99984 5.33335C9.99984 4.86669 9.91928 4.41669 9.75817 3.98335C9.59706 3.55002 9.3665 3.15558 9.0665 2.80002C9.22206 2.74446 9.37761 2.70835 9.53317 2.69169C9.68873 2.67502 9.84428 2.66669 9.99984 2.66669C10.7332 2.66669 11.3609 2.9278 11.8832 3.45002C12.4054 3.97224 12.6665 4.60002 12.6665 5.33335Z"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script lang="ts">
export default defineNuxtComponent({
  props: {
    size: {
      type: Number,
      default: 40
    },
    variant: {
      type: String,
      default: 'dark' // light, dark
    },
  },
  setup(props) {
    const color = (() => {
      if (props.variant === 'dark') {
        return '#303030'
      }
      if (props.variant === 'light') {
        return '#e5e5e5'
      }

      // Default: light
      return '#e5e5e5'
    })()

    return {
      color,
    }
  }
})
</script>
